import { render, staticRenderFns } from "./soundview.vue?vue&type=template&id=4f9c7d16&scoped=true&"
import script from "./soundview.vue?vue&type=script&lang=js&"
export * from "./soundview.vue?vue&type=script&lang=js&"
import style0 from "./soundview.vue?vue&type=style&index=0&id=4f9c7d16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c7d16",
  null
  
)

export default component.exports